<template>
  <el-form v-if="rowData" label-width="100px">
    <el-form-item :label="$t('integration.belonging_to')">
      {{ url }}
    </el-form-item>
    <el-form-item :label="$t('传感器编号')">
      <i v-icon="['equiStatusConvert', rowData.status]"></i>
      {{ rowData.tagId }}
    </el-form-item>
    <el-form-item :label="$t('配置状态')">
      {{ configStatus }}
    </el-form-item>
    <el-form-item :label="$t('integration.monitoring_point')">
      {{ rowData.carrierName }}
    </el-form-item>
    <el-form-item :label="$t('类型')">
      {{ $t(sensorTypeConvert(rowData.type).title) }}
    </el-form-item>
    <el-form-item :label="$t('描述')">
      {{ rowData.description }}
    </el-form-item>
  </el-form>
</template>

<script>
import { configStatusConvert, equiTypeConvert } from '@/utils/convert'
import { sensorTypeConvert } from '@/utils/dict/sensor'

export default {
  props: {
    rowData: {},
    sensorConfig: {}
  },
  computed: {
    url () {
      let url = this.rowData.scopeName
      if (this.rowData.sceneName) {
        url += '/' + this.rowData.sceneName
      }
      if (this.rowData.carrierName) {
        url += '/' + this.rowData.carrierName
      }
      return url
    },
    configStatus () {
      // 转换配置状态 默认已配置
      if (this.sensorConfig) {
        return this.$t(configStatusConvert(this.sensorConfig.status).title)
      } else {
        return this.$t(configStatusConvert(2).title)
      }
    }
  },

  data () {
    return {}
  },
  methods: {
    sensorTypeConvert,
    equiTypeConvert,
    configStatusConvert
  }
}
</script>
